export const depletionAreaLineParser = (data: any[]) => {
    try {
        let minVal = 0;
        let lineMinVal = Number.MAX_SAFE_INTEGER;
        let maxVal = 0;
        let lineMaxVal = 0;
        const lineKeyCy = 'price_cy';
        const lineKeyYa = 'price_ya';
        const areaKey = 'sales_cy';
        const dateKey = 'date';
        const parsedData = data?.map((item: any) => {
            const lineChartCyValue = item?.[lineKeyCy];
            const lineChartYaValue = item?.[lineKeyYa];
            const areaChartValue = item?.[areaKey];
            const dateValue = item?.[dateKey];
            minVal = Math.min(minVal, Number(areaChartValue));
            maxVal = Math.max(maxVal, Number(areaChartValue));
            lineMinVal = Math.min(lineMinVal, Number(lineChartCyValue), Number(lineChartYaValue));
            lineMaxVal = Math.max(lineMaxVal, Number(lineChartCyValue), Number(lineChartYaValue));
            const tempData = {
                lineDataCy: lineChartCyValue,
                lineDataYa: lineChartYaValue,
                areaData: areaChartValue,
                date: dateValue,
            };
            return tempData;
        });
        return { minVal, maxVal, lineMinVal, lineMaxVal, data: parsedData };
    } catch (error) {
        throw error;
    }
};
